import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const createAddress = createAsyncThunk(
  'address/create',
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post('https//api.monkeybox.ai/api/addresses', formData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchAddresses = createAsyncThunk(
  'address/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get('https//api.monkeybox.ai/api/addresses');
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateAddress = createAsyncThunk(
  'address/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const updatedAt = new Date().toISOString();
      const payload = { ...formData, updatedAt };
      const res = await axios.patch(`https//api.monkeybox.ai/api/addresses/${id}`, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const addressSlice = createSlice({
  name: 'address',
  initialState: {
    address: null,
    addresses: [],
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetAddressState(state) {
      state.success = false;
      state.error = null;
      state.address = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAddress.pending, (state) => {
        state.isLoading = true;
        state.success = false;
      })
      .addCase(createAddress.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.address = action.payload;
        state.addresses.unshift(action.payload);
      })
      .addCase(createAddress.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload || 'Failed to create address';
      })
      .addCase(fetchAddresses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAddresses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.addresses = action.payload;
      })
      .addCase(fetchAddresses.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch addresses';
      })
      .addCase(updateAddress.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.address = action.payload;
        state.addresses = state.addresses.map((addr) =>
          addr.id === action.payload.id ? action.payload : addr
        );
      });
  },
});

export const { resetAddressState } = addressSlice.actions;
export default addressSlice.reducer;
